import studentService from 'ApiService/Admin/studentService';
import Card from 'components/card';
import CardMenu from 'components/card/CardMenu';
import { AuthContext } from 'contexts/AuthContext';
import Nodatafound from 'pages/Common/Nodatafound';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { ThreeDots } from 'react-loader-spinner';
import BatchSwap from '../BatchSwap';

const AllStudents = ({ classData, courses, setCurrentStep }) => {
  const { state } = useContext(AuthContext);
  const [studentDetails, setStudentDetails] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [batches, setBatches] = useState([]);
  const selectedBranch = state?.selectedBranch || '';

  useEffect(() => {
    async function fetchStudents() {
      setLoading(true);
      try {
        const response = await studentService.getStudentsDetails(
          classData.courseId,
          classData.batchId,
          selectedBranch
        );
        if (response.data.success) {
          setStudentDetails(response.data.data);
          setLoading(false);
          if (response.data.length === 0) {
            toast.error(
              'No students found for the selected Standard and Division.'
            );
          }
        }
      } catch (error) {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      }
    }
    fetchStudents();
  }, [classData, selectedBranch]);

  useEffect(() => {
    let result = [...studentDetails];
    if (searchTerm) {
      result = result.filter(
        (student) =>
          student.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          student.email.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    setFilteredData(result);
  }, [studentDetails, searchTerm]);

  const handleAttendanceClick = async (student) => {
    setSelectedStudent(student);
    setShowDetails(true);

    const selectedCourse = courses.find(
      (course) => course.courseId === classData.courseId
    );
    const availableBatches = selectedCourse
      ? selectedCourse.batches.filter(
          (batch) => batch._id !== classData.batchId
        )
      : [];
    setBatches(availableBatches);
  };

  const handleBackClick = () => {
    setSelectedStudent(null);
    setShowDetails(false);
  };

  return (
    <div className="flex h-full items-center justify-center">
      {loading ? (
        <div className="flex h-40 items-center justify-center">
          <ThreeDots color="#5431ed" className="mt-100" />
        </div>
      ) : (
        <>
          {showDetails ? (
            <BatchSwap
              student={selectedStudent}
              batches={batches}
              currentBatchId={classData.batchId}
              currentCourseId={classData.courseId}
              handleBackClick={handleBackClick}
              setCurrentStep={setCurrentStep}
              selectedBranch={selectedBranch}
              courses={courses}
            />
          ) : (
            <Card extra="w-full sm:overflow-auto p-4">
              <div className="mt-2 flex w-full items-center justify-between px-1">
                <div className="text-xl font-bold text-navy-700 dark:text-white">
                  Select Student to Swap their batch
                </div>
                <CardMenu setItemsPerPage={setItemsPerPage} />
              </div>
              <div className="mt-2 flex flex-col items-center gap-4 sm:flex-row">
                <div className="w-full rounded-xl border border-gray-200 bg-lightPrimary py-2.5 pl-2.5 pr-3 text-sm font-normal text-gray-600 outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white sm:w-full md:w-full">
                  <input
                    type="text"
                    placeholder="Search."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="block w-full rounded-full bg-lightPrimary text-base text-navy-700 outline-none dark:!bg-navy-800 dark:text-white"
                  />
                </div>
              </div>
              <div className="mt-8 overflow-x-scroll xl:overflow-x-hidden">
                {filteredData.length === 0 ? (
                  <div className="mt-4 text-center text-gray-600 dark:text-white">
                    <p className="mt-0 text-center ">
                      <Nodatafound title="No Student data found" />
                    </p>
                  </div>
                ) : (
                  <table
                    className="w-full"
                    variant="simple"
                    color="gray-500"
                    mb="24px"
                  >
                    <thead>
                      <tr>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Sr No
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Name
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Email
                        </th>
                        <th className="border-b border-gray-200 pb-2 pl-4 pr-4 text-center text-sm font-bold tracking-wide text-gray-600 dark:text-white lg:text-xs">
                          Contact Number
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((student, index) => (
                        <tr
                          key={student._id}
                          onClick={() => handleAttendanceClick(student)}
                          className="cursor-pointer"
                        >
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {index + 1}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {student.name}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {student.email}
                          </td>
                          <td className="pb-2 pl-4 pr-4 pt-2 text-center text-sm font-bold text-navy-700 dark:text-white">
                            {student.contactNumber}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </Card>
          )}
        </>
      )}
    </div>
  );
};

export default AllStudents;
